<template>
    <div class="block-progress">
        <span class="block-progress__title">
            Интересы <br> и развитие
        </span>
        <p class="block-progress__text">
            Первые месяцы после рождения ребенок ест 7-10 раз в&nbsp;сутки и&nbsp;спит 80% времени. Так младенец набирается сил для роста и&nbsp;развития. И&nbsp;с&nbsp;каждым месяцем время сна и&nbsp;количество кормлений сокращаются, а&nbsp;время бодрствования растет.
            <br>
            <br>
            Примерно с&nbsp;6-8 месяцев ребенок начинает садиться и запоминать названия предметов, животных, цветов и форм. Он готов впитывать информацию в любое время: пока ест, гуляет, играет. Через несколько месяцев ребенок уже делает первые шаги. Увеличивается и количество игрушек: пирамидки, машинки, фермы, игрушечные пианино и телефоны захватывают территорию квартиры.
        </p>
        <div class="block-progress__img-box">
            <img
                srcset="../assets/0-img.jpg, ../assets/0-img@2x.jpg 2x"
                src="../assets/0-img.jpg"
                class="block-progress__img"
            />
        </div>
        <p class="block-progress__text">
            Двухлетнему малышу вполне по силам освоить детский транспорт: беговел, самокат или трехколесный велосипед. Еще ему нужно место, чтобы выплескивать свою энергию: где-то бегать, лазить, ползать, прыгать и общаться со сверстниками. Этим местом часто оказывается детская площадка. Постепенно ребенок учится разговаривать, может сказать, что хочет, чего боится или что его насмешило.
        </p>
        <BlockParallax class="block-progress__icon-box block-progress__toy-blue" speed="10" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/toy-blue.png, @/assets/images/icons/toy-blue@2x.png 2x"
                src="@/assets/images/icons/toy-blue.png"
                class="block-progress__icon"
            />
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__bottle-pink" speed="12" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/bottle-pink.png, @/assets/images/icons/bottle-pink@2x.png 2x"
                src="@/assets/images/icons/bottle-pink.png"
                class="block-progress__icon"
            />
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__bottle-blue" speed="8" direction="right" transform="rotate">
            <img
                srcset="@/assets/images/icons/bottle-blue.png, @/assets/images/icons/bottle-blue@2x.png 2x"
                src="@/assets/images/icons/bottle-blue.png"
                class="block-progress__icon"
            />
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__circle" speed="10" direction="right" transform="rotate">
            <img
                srcset="@/assets/images/icons/circle.png, @/assets/images/icons/circle@2x.png 2x"
                src="@/assets/images/icons/circle.png"
                class="block-progress__icon"
            />
        </BlockParallax>
        <BlockParallax class="block-progress__icon-box block-progress__toy-pink" speed="6" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/toy-pink.png, @/assets/images/icons/toy-pink@2x.png 2x"
                src="@/assets/images/icons/toy-pink.png"
                class="block-progress__icon"
            />
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'
export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-progress {
            position relative
            +layout-sm-and-up() {
                display flex
                padding: 0
                flex-wrap: wrap
            }
            +layout-md-and-up() {
                margin-left 8rem
            }

        &__title {
            display block
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            font-weight $font-semiBold
            color $color-text
            +layout-sm-and-up() {
                text-align center
                width 100%
                padding-right 7%
                font-size 3rem
                line-height 3.5rem
            }
            +layout-md-and-up() {
                margin-top 2rem
                text-align left
                position: absolute
                left 0
                padding-left: 0
            }
            br {
                display none
                +layout-md-and-up() {
                    display: block
                }
            }
        }
        &__img-box {
            margin 2rem -1rem 0

            +layout-sm-and-up() {
                width 100%
                margin-left 0
                margin-right 0
            }

            +layout-md-and-up() {
                width 100%
                margin 5rem 8rem 4rem 0
            }
        }

        &__img {
            width 100%
            height auto
        }

        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.7rem 0 0 0

            +layout-sm-and-up() {
                width 100%
            }

            +layout-md-and-up() {
                padding-left 25rem
                padding-right: 15rem
            }
        }

        &__toy-blue {
            position: absolute
            top 16rem
            left -4rem
            width: 8.6rem
            transform rotate(40deg)

            +layout-md-and-up() {
                top 28rem
                left -329px
                width 12.6rem
            }
        }

        &__bottle-pink {
            position: absolute
            right -4rem
            top 5rem
            transform rotate(-147deg)
            width 10rem
            z-index -1

            +layout-md-and-up() {
                right: -17rem
                width: 8.6rem
            }
        }

        &__bottle-blue {
            display none

            +layout-md-and-up() {
                display block
                position absolute
                top 9rem
                left -20rem
                width: 8.6rem
                transform rotate(-147deg)
            }
        }

        &__circle {
            width 3.4rem
            height 3.4rem
            position absolute
            top 44rem
            left 0
            transform rotate(-147deg)

            +layout-md-and-up() {
                top 29rem
                left -8rem
                width 5.4rem
                height 5.4rem
            }
        }

        &__toy-pink {
            width 9.7rem
            position absolute
            top 48rem
            right -5rem
            transform rotate(-55deg)

            +layout-md-and-up() {
                width 12rem
                top 21rem
                right -9rem
            }
        }
    }
</style>
